import { DUMMY_PROMO_CODE } from './constants'

export const isPromoCode = (code: string | null | undefined): boolean => {
  if (!code) return false

  return code === DUMMY_PROMO_CODE
}
